import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient } from "@shared/api/clients/apiClientFactory";
import { RecipientList, Templates } from "./types";
import { transformJsonToObject } from "@shared/utils/jsonToObjectTransformer";

const postDirectMessage = async (payload: any) => {
  const url = ApiEndpoints.createUrl("communication", "direct-message");
  const response = await communicationApiClient.post(url, payload);
  return response?.data;
};

const getRecipientLists = async (
  recipientType: string,
  remoteUtilityId: string
): Promise<RecipientList> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "recipient-lists",
    (query) => {
      query.push("is_pagination_required", 0);
      query.push("remote_utility_id", remoteUtilityId);
      query.push("recipient_type", recipientType);
    }
  );

  const response = await communicationApiClient.get(url);
  return transformJsonToObject<RecipientList>(response?.data);
};

const getTemplates = async (
  channelType: string,
  remoteUtilityId: string
): Promise<Templates[]> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "get-templates",
    (query) => {
      query.push("remote_utility_id", remoteUtilityId);
      query.push("channel_type", channelType);
      query.push("is_active", 1);
    }
  );

  const response = await communicationApiClient.get(url);
  console.log("TEMPLATEDDDDDD", response);
  return transformJsonToObject<Templates[]>(response?.data?.result);
};

const postBulkNotification = async (payload: any): Promise<any> => {
  const url = ApiEndpoints.createUrl("communication", "bulk-notification");
  const response = await communicationApiClient.post(url, payload);
  return response?.data;
};

export const uxMessagingApi = {
  postDirectMessage,
  getRecipientLists,
  getTemplates,
  postBulkNotification,
};
